import React from 'react'
import app from '../../../feathers'
import { injectState } from 'freactal'
import { Prompt, Link, Route } from 'react-router-dom'
import { Textfield } from 'react-mdl'
import styled from 'styled-components'
import Button from '../../../components/Button'
import BlockingSpinner from '../../components/BlockingSpinner'
import JSZip from 'jszip'
import ImageDialog from './ImageDialog'
import DisplayError from '../../../components/DisplayError'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const StyledTextfield = styled(Textfield)`
  width: 750px;
  margin: 0 30px;
`

class UnitSettings extends React.Component {
  state = this.getInitialState(this.props)
  getInitialState({ state: { unit } }) {
    return {
      _id: unit._id,
      code: unit.code,
      title: unit.title,
      topic: unit.topic,
      industry: unit.industry,
      saving: false,
      savePending: false,
      newImages: [],
      uploadError: null,
      loadingImages: false,
    }
  }

  handleChangeField = ({ target: { name, value } }) => {
    this.setState({ [`${name}`]: value, savePending: true })
  }
  handleSave = async () => {
    const { _id, code, title, topic, industry } = this.state
    this.setState({ saving: true })
    await app.service('units').patch(_id, {
      code,
      title,
      topic,
      industry,
    })
    this.setState({ saving: false, savePending: false })
  }
  handleFileUpload = async e => {
    const { code, title, topic, industry } = this.state
    try {
      this.setState({ loadingImages: true })
      const file = e.target.files[0]
      const fileBlob = await new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = () => resolve(fileReader.result)
        fileReader.onerror = err => reject(err)
        fileReader.readAsArrayBuffer(file)
      })
      const zip = new JSZip()
      const doc = await zip.loadAsync(fileBlob)
      const imageFiles = doc.filter(
        (path, file) => path.startsWith('word/media/') && !file.dir,
      )
      const newImages = await Promise.all(
        imageFiles.map(
          async image =>
            await zip.file(image.name).async('blob').then(data => ({
              image: new File([data], image.name, {
                type: `image/${image.name.split('.')[1]}`,
              }),
              description: `${code} ${title} ${topic} ${industry}`,
              tags: [code, title, topic, industry],
            })),
        ),
      )
      this.setState({ newImages, loadingImages: false })
    } catch (err) {
      this.setState({ uploadError: err })
    }
  }
  clearInput = () => {
    this.setState({ newImages: [] })
    this.fileInput.reset()
  }
  discardChanges = () => {
    this.clearInput()
    this.setState(this.getInitialState(this.props))
  }

  render() {
    const {
      _id,
      code,
      title,
      topic,
      industry,
      saving,
      savePending,
      newImages,
      loadingImages,
      uploadError,
    } = this.state

    return (
      <Container>
        <Route
          strict
          path="/units/:unitId/settings/images-preview"
          component={() =>
            <ImageDialog
              images={newImages}
              _id={_id}
              goBack={this.props.history.goBack}
              onSave={this.clearInput}
            />}
        />
        <h3>Unit Settings</h3>
        <Row>
          <h6>Unit Code</h6>
          <StyledTextfield
            required
            name="code"
            onChange={this.handleChangeField}
            label="Unit Code"
            value={code}
          />
        </Row>
        <Row>
          <h6>Unit Title</h6>
          <StyledTextfield
            required
            name="title"
            label="Unit Title"
            value={title}
            onChange={this.handleChangeField}
          />
        </Row>
        <Row>
          <h6>Unit Topic</h6>
          <StyledTextfield
            required
            name="topic"
            label="Unit Topic"
            value={topic}
            onChange={this.handleChangeField}
          />
        </Row>
        <Row>
          <h6>Unit Industry</h6>
          <StyledTextfield
            required
            name="industry"
            label="Unit Industry"
            value={industry}
            onChange={this.handleChangeField}
          />
        </Row>
        <Row>
          <h6>Upload Images from DOCX</h6>
          <form
            ref={input => {
              this.fileInput = input
            }}>
            <input
              type="file"
              accept=".docx"
              onChange={this.handleFileUpload}
            />
          </form>
          <Link to="./images-preview/current">
            <Button
              primary
              disabled={this.state.newImages.length === 0}
              onDisabledClick={e => e.preventDefault()}>
              Edit Images
            </Button>
          </Link>
        </Row>
        {uploadError !== null &&
          <DisplayError msg={uploadError.message} error={uploadError} />}
        <Row>
          <Button primary onClick={this.discardChanges}>
            Discard Changes
          </Button>
          <Button raised primary onClick={this.handleSave}>
            Save Changes
          </Button>
        </Row>
        {(saving || loadingImages) &&
          <BlockingSpinner>
            <h1>
              {saving ? 'Saving...' : 'Loading Images...'}
            </h1>
          </BlockingSpinner>}
        <Prompt
          when={savePending}
          message="You have unsaved changes. Are you sure you wish to discard them?"
        />
      </Container>
    )
  }
}

export default injectState(UnitSettings)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/UnitSettings/index.js